import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COLORS, FONT_FACE } from '../constants/theme';
import { ContainerStyles } from './styles/Container';

const StyledContainer = styled(ContainerStyles)`
  align-items: center;
  display: flex;
  flex-direction: row;
  min-width: 20rem;
  overflow: hidden;
  position: relative;
  user-select: none;
`;

const StyledNav = styled.nav`
  border: 1px solid ${props => props.theme.COLORS.GREY.platinumLight};
  background-color: ${props => props.theme.COLORS.GREY.mist};
`;

const StyledNavContainer = styled(StyledContainer)`
  min-height: 62px;

  font-size: 1.4rem;
  letter-spacing: .5px;
  line-height: 1.75rem;

  strong {
    font-family: ${FONT_FACE.BASE}
    font-size: 1.4rem;
  }

  button {
    cursor: pointer;
    font-size: 1.4rem
    height: 60px;
    border: none;
    padding: 0;
    border-bottom: 2px solid transparent;
    color: ${COLORS.BLACK};
    background-color: transparent;
    font-family: ${FONT_FACE.LIGHT};

    &[active='true'] {
      font-family: ${FONT_FACE.BASE};
      border-color: ${COLORS.BLACK};
    }
    &:hover {
      border-color: ${COLORS.BLACK};
    }
    &:focus {
      outline: none;
    }
  }

  > div {
    padding: 0 20px;

    &.devider {
      width: 0;
      &:after {
        content: '';
        border-left: 1px solid ${props => props.theme.COLORS.GREY.platinumLight};
        min-height: 30px;
        display: block;
      }
    }
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
      margin-left: auto;
    }
  }
`;

const Nav = ({ total, amount }) => (
  <StyledNav>
    <StyledNavContainer>
      <div>
        {amount} van in totaal {total} beoordelingen
      </div>
    </StyledNavContainer>
  </StyledNav>
);

Nav.propTypes = {
  total: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
};

export default Nav;
